export const ADD_ITEM_BAR_ITEM_HEIGHT = 58;
export const ADD_ITEM_BAR_ITEM_GAP = 12;
